import config from '@app/config';
import { Region } from '@app/enums/RegionList';
import Cover from '@components/PageBrandKama/image/cover.png';
import { StaticImageData } from 'next/image';

import { setModalVideoWhyChoose } from '@app/redux/slices/modalWindow';
import adsBrand from './ads_brand';
import adsCatalogTyres from './ads_catalog_tyres';

const { baseImageUrl } = config;

export type AdBannerOptions = {
  widthDesktop: number;
  widthMobile?: number;
  heightDesktop: number;
  heightMobile?: number;
};

export interface AdBanner {
  name?: string;
  href?: string;
  imageDesktop: string | StaticImageData;
  imageMobile?: string | StaticImageData;
  handlerAction?: any;
  erid?: string;
  options?: AdBannerOptions;
}

export interface Ads {
  href: string;
  regions?: Region[];
  excludeRegions?: Region[];
  slot?: string;
  banners: AdBanner[];
  isHideRegionsPvz?: boolean;
}

const ads: Ads[] = [
  {
    href: '^/$',
    banners: [
      {
        imageDesktop: `${baseImageUrl}/upload/medialibrary/banners/13_2854.jpg`,
        imageMobile: `${baseImageUrl}/upload/medialibrary/banners/13_2853.jpg`,
        href: '/actions/rassrochka/',
      },
    ],
  },
  {
    href: '/catalog/tyres/$',
    slot: 'brand',
    banners: [
      {
        imageDesktop: 'https://koleso.ru/upload/medialibrary/banners/13_3129.jpg',
        imageMobile: 'https://koleso.ru/themes/tireshop2/images/actions/8c22d759816107e20d4eda0d714cbda4.png',
        href: '/actions/gotov-shinyi-letom-hranenie-i-montaj-besplatno/',
        name: 'Готовь шины летом!',
        erid: '2W5zFGKUzhv',
        options: {
          widthDesktop: 2280,
          widthMobile: 634,
          heightDesktop: 300,
          heightMobile: 414,
        },
      },
    ],
  },
  {
    href: '/catalog/discs/$',
    regions: [
      Region.Novosibirsk,
      Region.Kazan,
      Region.NizhnyNovgorod,
      Region.Voronezh,
      Region.Perm,
      Region.Ufa,
      Region.SaintPetersburg,
      Region.Moscow,
      Region.Samara,
      Region.RostovOnDon,
    ],
    slot: 'brand',
    banners: [
      {
        href: '/actions/rasprodaja-do-60_-na-lityie-diski-msk/',
        imageDesktop: 'https://koleso.ru/upload/medialibrary/banners/13_3097.jpg',
        imageMobile: 'https://koleso.ru/upload/medialibrary/banners/13_3098.jpg',
        name: 'Распродажа до 60% на литые диски',
        erid: '2W5zFFzTa5N',
        options: {
          widthDesktop: 3420,
          widthMobile: 1268,
          heightDesktop: 450,
          heightMobile: 828,
        },
      },
    ],
  },
  {
    href: '/catalog/tyres/kama/$',
    banners: [
      {
        imageDesktop: Cover,
        imageMobile: Cover,
        options: {
          widthDesktop: 1140,
          heightDesktop: 300,
          widthMobile: 1140,
          heightMobile: 300,
        },
      },
    ],
  },
  {
    href: '/catalog/accumulators/$',
    excludeRegions: [Region.Novosibirsk, Region.Hab],
    banners: [
      {
        name: 'Покупайте аккумулятор со скидкой до 1100 рублей и бесплатной заменой',
        erid: 'LjN8KHjqz',
        imageDesktop: `${baseImageUrl}/upload/medialibrary/banners/13_3122.jpg `,
        imageMobile: `${baseImageUrl}/upload/medialibrary/banners/13_3123.jpg`,
        href: '/actions/akkumulyatoryi-110/',
        options: {
          heightMobile: 511,
          widthMobile: 1280,
          heightDesktop: 168,
          widthDesktop: 1280,
        },
      },
    ],
    isHideRegionsPvz: true,
  },
  {
    href: '/catalog/oils/$',
    banners: [
      {
        imageDesktop: `${config.baseImageUrl}/articles/wp-content/uploads/2024/02/Koleso.ru_15sale_autotovars2024_1140х100.jpg`,
        imageMobile: `${config.baseImageUrl}/themes/tireshop2/images/actions/0ea48c4d1f4cf1e5eea5f8b9574390c1.jpg`,
        href: '/actions/skidka-15-na-avtozapchasti/',
        options: {
          heightMobile: 414,
          widthMobile: 634,
          heightDesktop: 100,
          widthDesktop: 1140,
        },
      },
    ],
  },
  {
    href: '/shops/$',
    banners: [
      {
        imageDesktop: `${baseImageUrl}/upload/medialibrary/banners/13_2857.png`,
        imageMobile: `${baseImageUrl}/upload/medialibrary/banners/13_2858.png`,
        handlerAction: setModalVideoWhyChoose(),
        options: {
          heightDesktop: 189,
          widthDesktop: 1440,
          heightMobile: 460,
          widthMobile: 1153,
        },
      },
    ],
    isHideRegionsPvz: true,
  },
  ...adsBrand,
  ...adsCatalogTyres,
];

export default ads;
